import axios from "axios";
import { WalletSummaryResponse } from "redmond";
import { config } from "../../config";
import { travelWalletApiPrefix } from "../paths";

const END_POINT: string = `${travelWalletApiPrefix}`;

export const fetchTravelWalletSummary =
  async (): Promise<WalletSummaryResponse> => {
    const res = await axios.get(END_POINT, {
      baseURL: config.baseURL,
    });
    return res.data;
  };
